import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { CardContent, CardMedia } from '@mui/material';

import { Poetry } from 'api/poetryClub';
import { Card, Title } from 'common';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../../context/LanguageContext'

interface PoetryCardProps {
    poetryItem: Poetry;
}

export const PoetryCard = ({ poetryItem }: PoetryCardProps) => {
    const { language } = useLanguage();
    const title = poetryItem[`title_${language}`] || poetryItem.title;
    const description = poetryItem[`description_${language}`] || poetryItem.description;

    return (
        <Link to={`/poetry-club/${poetryItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ maxWidth: 345, marginBottom: 2, border: '1px solid #af0000' }}>
                {poetryItem.images && poetryItem.images.length > 0 && poetryItem.images[0] ? (
                    <CardMedia
                        component="img"
                        height="200"
                        sx={{ borderRadius: 1 }}
                        image={poetryItem.images[0].photo}
                        alt={title}
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // количество строк, для отображения
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {title}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, // количество строк, для отображения
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{
                            __html: description
                        }} />
                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(poetryItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
